import { defaultAccountState } from "../const";

const accountAction = {
  initializeState: 'INITIALIZE_STATE',
  changeName: 'CHANGE_NAME',
  changeEmail: 'CHANGE_EMAIL',
  changeAccessPrivilegeRole: 'CHANGE_ACCESS_PRIVILIEGE_ROLE',
  changeManagedMSP: 'CHANGE_MANAGED_MSP',
  changeManagedSiteTag: 'CHANGE_MANAGED_SITE_TAG',
  renewManagedSite: 'RENEW_MANAGED_SITE'
}

const accountReducer = (state, action) => {
  switch (action.type) {
    case accountAction.initializeState:
      return {
        ...state,
        ...action.payload
      }
    case accountAction.changeName:
      return {
        ...state,
        name: action.payload
      };
    case accountAction.changeEmail:
      return {
        ...state,
        email: action.payload
      };
    case accountAction.changeAccessPrivilegeRole:
      return {
        ...state,
        accessPrivilegeRole: action.payload
      };
    case accountAction.changeManagedMSP:
      return {
        ...state,
        managedMSP: action.payload
      };
    case accountAction.changeManagedSiteTag:
      return {
        ...state,
        managedSiteTag: action.payload
      };
    case accountAction.renewManagedSite:
      return {
        ...state,
        managedSite: action.payload
      };
    default:
      return defaultAccountState;
  }
};

export default {
  defaultState: defaultAccountState,
  action: accountAction,
  reducer: accountReducer
}